// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__-yZ7V","list":"BalanceDue_list__1xpU0","listRow":"BalanceDue_listRow__9eiqe","total":"BalanceDue_total__knfBt"};